import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_BLUE,
    codeProp: 'uiUserCode',
    detailUrl: '/UiDetail',
    detailIdProp: 'uiId',
    listUrl: '/UiList',
    mapProp: 'uiMap',
    name: '用户界面',
    textProp: 'uiName',
    type: 'UI',
}
